<template>
  <div class="wrapper">
    <inner-list
      :loading="loading"
      :results="results"
      :pagination="pagination"
      @editInstance="openModal"
      @deleteInstance="handleDelete"
    />
    <a-button v-if="canAdd" type="primary" icon="plus" @click="openModal">
      Dodaj materiały dydaktyczne
    </a-button>
    <material-modal ref="materialModal" @formSubmitted="fetchData" />
  </div>
</template>
<script>
import InnerList from './InnerList'
import { Material } from '@/api'
import PaginatedList from '@/components/layout/PaginatedList'
import MaterialModal from '@/components/modals/MaterialModal'

export default {
  extends: PaginatedList,
  components: {
    InnerList,
    MaterialModal
  },
  methods: {
    openModal({ instanceId }) {
      this.$refs.materialModal.openModal({
        instanceId,
        courseId: this.courseId,
        forWhom: this.forWhom
      })
    },
    handleDelete(instanceParams) {
      this.deleteInstance(instanceParams, {
        title: 'Usuń materiały dydaktyczne',
        content: 'Czy na pewno chcesz usunąć materiały dydaktyczne?'
      })
    }
  },
  data() {
    return {
      service: Material
    }
  },
  props: {
    courseId: {
      type: [String, Number],
      required: false
    },
    forWhom: {
      type: [String],
      default: 'for_course'
    }
  },
  computed: {
    canAdd() {
      return this.forWhom === 'for_course' || this.isAdmin
    },
    params() {
      const course = this.courseId
      return {
        ...this.$route.query,
        for_whom: this.forWhom,
        course
      }
    }
  }
}
</script>
